import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { UploadMappingsResponseDto } from './dtos/external-buyer-mappings.dto';

@Injectable({ providedIn: 'root' })
export class ExternalBuyerMappingsApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);
  private readonly _baseUrl = `${this._env.pureSpectrum.buyerExternalIntegrationUrl}/api/v1/integrations`;

  public uploadMappings(
    file: File,
    buyerId: string,
    buyerKey: string,
  ): Observable<UploadMappingsResponseDto> {
    const formData = new FormData();
    formData.append('key', buyerKey);
    formData.append('mappings', file);
    return this._http.post<UploadMappingsResponseDto>(
      `${this._baseUrl}/${buyerId}/qualification-mappings`,
      formData,
      { headers: { skipInterceptor: 'true' } },
    );
  }

  public downloadMappings(id: string): Observable<Blob> {
    return this._http.get(
      `${this._baseUrl}/${id}/qualification-mappings/download`,
      { responseType: 'blob' },
    );
  }
}
